module.exports = __webpack_public_path__ + "img/banner.c4e7b0ae.jpg";